// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { getFallbackConfig, getConfig } from '~/src/config/env';

const isServer = typeof window === 'undefined';

// Get config and create client
const config = getFallbackConfig();

let currentUrl = config.supabase.url;
let currentAnonKey = config.supabase.anonKey || '';

function makeClient(url: string, anonKey: string): SupabaseClient {
  return createClient(url, anonKey, {
    auth: {
      storage: isServer ? undefined : localStorage,
      persistSession: !isServer,
      autoRefreshToken: !isServer,
      detectSessionInUrl: !isServer,
    },
    realtime: {
      params: { eventsPerSecond: 10 },
      heartbeatIntervalMs: 30000,
      reconnectAfterMs: (tries: number) => Math.min(tries * 100, 3000),
    },
    global: {
      headers: {
        'X-Client-Info': 'control-exchange-web',
        apikey: anonKey || '',
      },
    },
  });
}

// Create a (possibly incomplete) client; we will upgrade it at runtime if needed
export let supabase: SupabaseClient = makeClient(currentUrl, currentAnonKey);

// Ensure a working client with a valid anon key (useful when env vars are missing in prod)
export async function ensureSupabaseClient(): Promise<SupabaseClient> {
  if (currentAnonKey && currentAnonKey.length > 10) return supabase;
  try {
    const cfg = await getConfig();
    if (cfg?.supabase?.anonKey && cfg?.supabase?.url) {
      currentAnonKey = cfg.supabase.anonKey;
      currentUrl = cfg.supabase.url;
      supabase = makeClient(currentUrl, currentAnonKey);
    }
  } catch (err) {
    // swallow; fallback client will continue to operate
    console.warn('ensureSupabaseClient: failed to fetch config', err);
  }
  return supabase;
}
